const MAX_KEYS = 12;
const MAX_STRING = 200;

export function sanitizeNotificationMetadata(
  value: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined {
  if (!value) return undefined;
  const out: Record<string, unknown> = {};
  let count = 0;
  for (const [key, raw] of Object.entries(value)) {
    if (count >= MAX_KEYS) break;
    const lower = key.toLowerCase();
    if (
      lower.includes('token') ||
      lower.includes('password') ||
      lower.includes('secret')
    ) {
      continue;
    }
    if (typeof raw === 'string') {
      out[key] =
        raw.length > MAX_STRING ? `${raw.slice(0, MAX_STRING)}…` : raw;
    } else if (
      typeof raw === 'number' ||
      typeof raw === 'boolean'
    ) {
      out[key] = raw;
    } else if (raw === null) {
      out[key] = null;
    }
    count += 1;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
